























































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import MultiFileUpload from "@/components/common/Inputs/MultipleFileUpload.vue";
import HeaderInfo from "../../ExpansionPanel/FinExpansionPanel.vue";
import NavButtons from "@/components/common/Buttons/NavButtons.vue";
import FileDownload from "@/components/common/fileDownload/fileDownload.vue";
import SampleDocument from "./Components/SampleDocument.vue";

const namespace: string = "financialReport";

@Component({
  components: {
    FileUpload,
    MultiFileUpload,
    HeaderInfo,
    NavButtons,
    FileDownload,
    SampleDocument,
  },
})
export default class FinDocs extends Vue {
  @Action("showLoading", {namespace:"application"} ) showLoading: any;
  @Action("hideLoading", {namespace:"application"} ) hideLoading: any;
  @Prop() docTags: any;
  @Prop() docCategories: Array<any>;
  @Prop() requestedAuditDocs: Array<any>;
  @Prop() model: any;
  @Prop() readOnly: boolean;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @State(namespace) financialReport: FinancialReportData;
  @Getter("selectedReport", { namespace }) report: any;
  @Getter("grantInfo", { namespace }) grantInfo: any;
  @Prop() financialReportSections: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() enableButton: any;
  finDocsKey: number = 1;
  expand = [0];
  enabledStatus = [_app.finReportStatus.inProgress, _app.finReportAuditStatus.inProgress];
  @Prop() userRoles: any;
  isAuditor: boolean = false;

  mounted() {
    this.addEmptyRow();    
    this.checkPermission();
  }

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find((x) => x.RowKey === rowKey);
    } else {
      return null;
    }
  }

  get finDocs() {
    if (!this.model.finReportDocuments) this.model.finReportDocuments = [{}];

    return this.model.finReportDocuments;
  }

  get additionaDocs() {
    return this.finDocs.filter((x) => !x.categoryId);
  }

  addEmptyRow() {
    if (this.finDocs) {
      const emptyRow = this.finDocs.find((x) => Object.keys(x).length === 0);
      if (!emptyRow) {
        this.finDocs.push({});
      }
    }
    this.finDocsKey += 1;
  }

  /** get the category doc */
  categoryDoc(catg, tag) {
    return this.finDocs.filter(
      (x) => x.categoryId == catg.id && x.docType == tag.DocumentTagId
    );
  }

  checkPermission() { 
    if(this.userRoles == _app.appRoles.Auditor){
        this.isAuditor = true;
    }
   
    return this.isAuditor;
  }

  /*** add the category document */
  addCategoryDoc(e, catg, tag) {
    this.showLoading()
    const { name, type, size } = e;
    this.$services.document
      .uploadDocument(
        e,
        {
          options: {
            docTag: tag.DocumentTagId,
            menu: _app.menu.finReport,
          },
        },
        this.financialReport.selectedReport.FinancialReportId,
        this.$vuetify.lang.current
      )
      .then((data) => {
        var doc = {
          categoryId: catg.id,
          categoryName: catg.name,
          docType: tag.DocumentTagId,
        };
        Object.assign(doc, data, { name, type, size });
        this.finDocs.push(doc);
        this.finDocsKey += 1;
        this.hideLoading()
      }).catch(e=>{
        this.hideLoading()
      });
    this.$emit("input", true);
  }

  onAddFiles(e, doc) {
    this.showLoading()
    const { name, type, size } = e;
    this.$services.document
      .uploadDocument(
        e,
        {
          options: {
            docTag: doc.docType,
            menu: _app.menu.finReport,
          },
        },
        this.financialReport.selectedReport.FinancialReportId,
        this.$vuetify.lang.current
      )
      .then((data) => {
        Object.assign(doc, data, { name, type, size });
        this.addEmptyRow();
        this.$emit('fileChange', e);
        this.hideLoading();
      }).catch(e=>{
        this.hideLoading()
      });

    this.$emit("input", true);
  }

  /** Remove category doc */
  onRemoveCategoryDoc(catg, tag) {
    const index = this.finDocs.findIndex(
      (x) => x.categoryId == catg.id && x.docType == tag.DocumentTagId
    );
    const doc = this.finDocs[index];
    if (doc && doc.documentId) {
      this.$services.document.removeDocument(doc).then((data) => {
        this.finDocs.splice(index, 1);
        this.finDocsKey += 1;
      });
    }
    this.$emit("input", true);
  }

  /** Remove the document */
  removeFile(doc) {
    var index = this.finDocs.findIndex((x) => x.documentId == doc.documentId);
    if (index >= 0) {
      this.$services.document.removeDocument(doc).then((data) => {
        this.finDocs.splice(index, 1);
        this.addEmptyRow();
      });
    }
    this.$emit("input", true);
  }

  onRemoveFile(index, doc) {
    if (doc.documentId) {
      this.$services.document.removeDocument(doc).then((data) => {
        this.finDocs.splice(index, 1);
        this.addEmptyRow();
      });
    } else {
      this.finDocs.splice(index, 1);
      this.addEmptyRow();
    }
    this.$emit("input", true);
  }  
}
